<template>
   <footer id="footer" >
      <div class="top">
         <a href="/" title="Homepage"><LogoIcon /></a>
      </div>
      <div class="left">
         <nav>
            <ul>
               <li><NuxtLink href="/about">About the Site</NuxtLink></li>
               <li><NuxtLink href="/privacy">Privacy Policy</NuxtLink></li>
               <li><NuxtLink href="/terms">Terms & Conditions</NuxtLink></li>
               <template v-if="authed">
                  <li><NuxtLink to="/dance-credits">Dance - Credits</NuxtLink></li>
                  <li><NuxtLink to="/drama-credits">Drama - Credits</NuxtLink></li>
                  <li><NuxtLink to="/music-credits">Music - Credits</NuxtLink></li>
               </template>
            </ul>
         </nav>
      </div>
      <div class="right" v-if="authed">
         <ul>
            <li><NuxtLink class="h3 serif" to="/">Explore</NuxtLink></li>
            <li><NuxtLink class="h3 serif" to="/help-center">Help Center</NuxtLink></li>
            <li><NuxtLink class="h3 serif" to="/pd">PD Courses</NuxtLink></li>

            <li><NuxtLink class="h3 serif" to="/discipline/dance">Dance</NuxtLink></li>
            <li><NuxtLink class="h3 serif" to="/discipline/drama">Drama</NuxtLink></li>
            <li><NuxtLink class="h3 serif" to="/discipline/music">Music</NuxtLink></li>
         </ul>
         <div class="bottom-bar">
            <span class="p xsmall">
               © {{ new Date().getFullYear() - 1 }} -
               {{ new Date().getFullYear() }} Juilliard Creative Classroom</span
            >
            <span class="p xsmall">All rights reserved.</span>
         </div>
      </div>
   </footer>
</template>
<script setup lang="ts">
import LogoIcon from "~/assets/images/logo.svg?component";
const authedStore = useAuthStore();
const { authed } = storeToRefs(authedStore);

// >> LIFE CYCLES ------------------------------------------------------
</script>
<style lang="scss">
@import url("~/assets/scss/footer.scss");
</style>
